import React, { useState } from 'react';
import {
  MultiSelect,
  MultiSelectHeaderCheckboxChangeEvent,
  MultiSelectProps,
  MultiSelectTemplateOptions,
} from 'primereact/multiselect';
import { PMultiSelectStyle as S } from './PMultiSelect.style';
import { useClassNames } from 'hooks/useClassNames';
import { PCheckbox, PCheckboxIcon } from '../PCheckbox/PCheckbox';
import { Search } from 'components/Search/Search';
import { Icon } from 'components/Icon/Icon';
import { PDropdownPropsSeverity } from '../PDropdown/PDropdown';
import { Box } from 'components/layouts/primitives/Box/Box';
import { HStack } from 'components/layouts/primitives/Stack/Stack';
import { Text } from 'components/Text/Text';

const PMultiSelectFilterTemplate: React.FC<MultiSelectTemplateOptions> = (props) => {
  return <Search onChange={(e) => props.filterOptions?.filter?.(e as any)} />;
};

const PMultiSelectPanelHeader: React.FC<{
  onChange: (e: MultiSelectHeaderCheckboxChangeEvent) => void;
  className: string;
  checked: boolean;
}> = ({ onChange, className, checked }) => {
  return (
    <Box
      className="custom-panel-header-select-all"
      onClick={(e) => onChange(e as unknown as MultiSelectHeaderCheckboxChangeEvent)}
    >
      <HStack className={className} align="center">
        <PCheckbox checked={checked} />
        <Text>Select all</Text>
      </HStack>
    </Box>
  );
};

export const PMultiSelect = React.forwardRef<
  MultiSelect,
  MultiSelectProps & {
    severity?: PDropdownPropsSeverity;
    containerClassName?: string;
    fixedWidth?: boolean;
  }
>((props, ref) => {
  const cleanProps = React.useMemo(
    () => (({ severity, containerClassName, fixedWidth, ...o }: any) => o)(props),
    [props]
  );
  const [overlayVisible, setOverlayVisible] = useState(props.overlayVisible);

  const classNames = useClassNames(
    {
      'overlay-panel-visible': overlayVisible,
      'has-value': !!props.value?.length,
      [`p-multiselect-${props.severity || 'outlined'}`]: true,
    },
    props.className
  );

  const panelClassName = useClassNames({ 'fixed-width': props.fixedWidth }, props.panelClassName);

  return (
    <S.Container className={props.containerClassName}>
      <S.MultiSelect
        {...cleanProps}
        className={classNames}
        onShow={() => {
          props.onShow?.();
          setOverlayVisible(true);
        }}
        onHide={() => {
          props.onHide?.();
          setOverlayVisible(false);
        }}
        dropdownIcon={<Icon icon="chevronDownLine" />}
        checkboxIcon={<PCheckboxIcon />}
        itemCheckboxIcon={<PCheckboxIcon />}
        filterTemplate={PMultiSelectFilterTemplate}
        panelHeaderTemplate={
          !props.filter &&
          ((event) => {
            return (
              <PMultiSelectPanelHeader
                onChange={event.onChange}
                className={event.className}
                checked={event.checked}
              />
            );
          })
        }
        clearIcon={
          <Box onClick={(e) => props.onChange?.({ ...e, value: null } as any)}>
            <Icon icon="xCircleSolid" className="p-multiselect-clear-icon" />
          </Box>
        }
        panelClassName={panelClassName}
        ref={ref}
      />
      <Icon icon="alertCircleSolid" className="p-dropdown-invalid-icon" />
    </S.Container>
  );
});
